// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3XRBH","select":"Header_select__3Zij2","clinic":"Header_clinic__3EH2M"};